export const BUTTON_VARIANTS = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary",
  LINK: "link",
  DANGER: "danger",
};

export const BUTTON_TYPES = {
  BUTTON: "button",
  LINK: "link",
};

export const BUTTON_SIZES = {
  EXTRA_SMALL: "extra-small",
  SMALL: "small",
  LARGE: "large",
};

export const BUTTON_TARGETS = {
  BLANK: "_blank",
};

export const BUTTON_SHAPES = {
  SQUARE: "square",
  CIRCLE: "circle",
};
